import type { RoadPath } from './road-paths';
import type { TownData } from '@/game/types';
import { buildWorldTerrainContext, roadPOIPaths, type WorldTerrainContext } from './procedural';

/** One terrain boundary for the game, editor and saved-layout previews. */
export function townTerrainContext(towns: readonly TownData[], route: Array<{x:number;y:number}> | null = null,
  roads: Array<Array<{x:number;y:number}>> = []): WorldTerrainContext {
  const influences = towns.filter(t => t.biome !== 'road' || t.authored !== undefined).map(t => {
    const points = [...(t.authored?.streets.flatMap(s => s.points) ?? []), ...(t.authored?.fortifications?.perimeter ?? [])];
    return {
      id:t.id, cx:t.centerX, cy:t.centerY, radius:t.radius,
      biome:t.authored?.terrainBiome ?? t.biome, levelMin:t.levelMin, authored:t.authored !== undefined,
      ...(t.authored?.fortifications ? {authoredPerimeter:t.authored.fortifications.perimeter.map(p=>({...p}))} : {}),
      ...(points.length ? {authoredBounds:{
        minX:Math.min(...points.map(p=>p.x))-(t.authored?.fortifications?2:0),maxX:Math.max(...points.map(p=>p.x))+(t.authored?.fortifications?2:0),
        minY:Math.min(...points.map(p=>p.y))-(t.authored?.fortifications?2:0),maxY:Math.max(...points.map(p=>p.y))+(t.authored?.fortifications?2:0),
      }} : {}),
    };
  });
  const paths:RoadPath[]=[...roads.map(points=>({points,kind:'main' as const})),...roadPOIPaths([...towns])];
  return {...buildWorldTerrainContext(influences,route,paths.map(path=>path.points)),roadPaths:paths};
}
